import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import { authOperations } from '../containers/Login/state';
import { Container } from 'react-bootstrap'
import StoreHeader from './StoreHeader';
import { STORE_LOGIN_ROUTE } from '../containers/Login/routes';

class PrivateStoreRoute extends Component {
    render() {
        return this.props.isStoreAuthenticated ? (
            <div>
                <StoreHeader {...this.props} />

                <div className='appMainDiv'>
                    <Container fluid>
                        <Route path={this.props.path} component={this.props.component} />
                    </Container>
                </div>
            </div>)
            : (
                <Redirect to={{
                    pathname: STORE_LOGIN_ROUTE,
                    state: {
                        from: this.props.location
                    }
                }} />
            )
    }
}

const mapStateToProps = (state) => {
    return {
        isStoreAuthenticated: state.auth.isStoreAuthenticated,
        storeDetails: state.auth.storeDetails
    }
};

const mapDispatchToProps = {
    logoutStore: authOperations.logoutStore
};

export default connect(mapStateToProps, mapDispatchToProps)(PrivateStoreRoute);